/**
 * PREVIEW COMPANY TABLE VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import {POST} from './../../../constants';

import CustomTableBody from './../../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import InfiniteScrollTable from './../../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';
import SortIndicator from './../../../reusable/SortIndicators/SortIndicators.index.jsx';
import CountBox from './../../../reusable/CountBox/CountBox.index.jsx';
import SelectOptionsLanguage from './../../../reusable/Dropdowns/SelectOptionsLanguage.jsx';
import SelectOptionsPestle from './../../../reusable/Dropdowns/SelectOptionsPestle';
import SelectOptionsRisks from './../../../reusable/Dropdowns/SelectOptionsRisks';

/**
 * Generates the infinite scroll table for the Review companies page.
 *
 * @constructor
 * @param   {string}   props.tableId           The table ID.
 * @param   {Array}    props.columnWidths      The column widths, in percentages.
 * @param   {Array}    props.rowsModel         The model for the table rows.
 * @param   {string}   props.url               The table base URL from which the entries will be fetched.
 * @param   {Object}   props.urlParams         Custom parameters that will be appended to the table URL.
 * @param   {Object}   props.eventHandlers     Event handlers to be attached to the infinite scroll table.
 * @param   {Array}    props.categoryOptions   The categories that the user can choose from, for filtering purposes.
 * @param   {Object}   props.userActions
 * @return  {HTML}
 */
class PreviewTable extends React.Component {

    constructor(props) {
        super(props);
        this.showNothingToBeDisplayed = [];
    }

    render() {

        let params;
        if (this.props.verb === POST) {
            params = this.props.tableRequestPayload;
        } else {
            params = this.props.urlParams;
        }

        let dateSortDirection = params.direction ? params.direction : null;

        return (
            <InfiniteScrollTable tableId={this.props.tableId}
                                 columnWidths={this.props.columnWidths}
                                 rowsModel={this.props.rowsModel}
                                 eventHandlers={this.props.eventHandlers}>
                <thead className="custom-table-head">
                    <tr>

                        <th>
                            <CountBox totalCount={this.props.count} partialCount={this.props.filterCount} />
                        </th>

                        <th>
                            <SelectOptionsLanguage language={params.language}
                                                   onChange={this.props.userActions.filterByLanguage} />
                        </th>
                        <th>
                            <span onClick={this.props.userActions.sortByDate}>
                                <FormattedMessage id="Entities_Preview_UIText_previewCompanies.date" />
                                <SortIndicator direction={dateSortDirection} />
                            </span>
                        </th>

                        <th>
                            <div className="select-wrapper">
                                <SelectOptionsPestle
                                    pestle={params.riskAngle}
                                    onChange={this.props.userActions.sortByRiskAngle} />
                                <SelectOptionsRisks
                                    riskLevel={params.riskLevel}
                                    onChange={this.props.userActions.sortByRiskLevel} />
                            </div>
                        </th>
                    </tr>
                </thead>
                <CustomTableBody ref="previewCompanyTableBody"
                                 tableId={this.props.tableId}
                                 url={this.props.url}
                                 startPageNumber="0"
                                 pageSize="50"
                                 nestedObject="articleList"
                                 urlParams={this.props.urlParams}
                                 tableRequestPayload={this.props.tableRequestPayload}
                                 preventScrollToTop={this.props.preventScrollToTop}
                                 dataStore={this.props.initializeEmptyTable ? this.showNothingToBeDisplayed : null}
                                 verb={this.props.verb}
                                 lifecycleEvents={this.props.lifecycleEvents} />
            </InfiniteScrollTable>
        );

    }

}

export default PreviewTable;


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/template/PreviewCompany.previewTable.jsx